<template lang="pug">
.donation-technical-error
	VueFeedback(type="error")
		template(slot="feedback-title") Technical error!
		template(slot="feedback-content")
			p Technical error occured! Please try again later!
</template>
<script>
import VueFeedback from '@ui-common/vue-feedback';
export default {
	components: {
		VueFeedback
	},
	mounted() {
		this.$scrollTo(this.$el);
	}
};
</script>

<style lang="scss" scoped>
.donation-technical-error {
	margin-bottom: 48px;
}
</style>
